"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const _1 = require(".");
let WorkflowUpdateInput = class WorkflowUpdateInput extends _1.WorkflowCreateInput {
};
tslib_1.__decorate([
    type_graphql_1.Field(),
    class_validator_1.IsNotEmpty(),
    tslib_1.__metadata("design:type", String)
], WorkflowUpdateInput.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], WorkflowUpdateInput.prototype, "emailId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [type_graphql_1.ID], { nullable: true }),
    tslib_1.__metadata("design:type", Array)
], WorkflowUpdateInput.prototype, "usersThatCanApproveIds", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [type_graphql_1.ID], { nullable: true }),
    tslib_1.__metadata("design:type", Array)
], WorkflowUpdateInput.prototype, "usersToSendProofsToIds", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    tslib_1.__metadata("design:type", Array)
], WorkflowUpdateInput.prototype, "days", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], WorkflowUpdateInput.prototype, "everyday", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], WorkflowUpdateInput.prototype, "sendProof", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], WorkflowUpdateInput.prototype, "minutesBeforeRunToSendProof", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], WorkflowUpdateInput.prototype, "time", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], WorkflowUpdateInput.prototype, "requireApproval", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], WorkflowUpdateInput.prototype, "emailServiceProviderId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsEmail(),
    tslib_1.__metadata("design:type", String)
], WorkflowUpdateInput.prototype, "campaignFromEmailAddress", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], WorkflowUpdateInput.prototype, "campaignDefaultSubjectLine", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], WorkflowUpdateInput.prototype, "campaignFromName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsEmail(),
    tslib_1.__metadata("design:type", String)
], WorkflowUpdateInput.prototype, "campaignReplyToEmailAddress", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], WorkflowUpdateInput.prototype, "campaignListID", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], WorkflowUpdateInput.prototype, "campaignSubjectLineSource", void 0);
WorkflowUpdateInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], WorkflowUpdateInput);
exports.WorkflowUpdateInput = WorkflowUpdateInput;
//# sourceMappingURL=WorkflowUpdateInput.js.map